import { Slice, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type RegistrationRequestsSliceStateType = {
  items: any[] | [];
  totalItems: number;
  isTableLoading: boolean;
  page: number;
  rowsPerPage: number;
  searchValue: string;
  requestStartDate: string | null;
  requestEndDate: string | null;
  actionStartDate: string | null;
  actionEndDate: string | null;
  actionBy: any;
  requestStatus:any ;
  isShowMarkSpam:boolean ;
  batch: any;
  sortValue: { field: string; value: "DESC" | "ASC" };
  filterBy: {
    fieldName: string;
    value: string[];
  }[];
  dateFilter: {
    start_date: string | null;
    end_date: string | null;
  };
};

const initialState: RegistrationRequestsSliceStateType = {
  items: [],
  totalItems: 0,
  isTableLoading: true,
  page: 1,
  rowsPerPage: 20,
  searchValue: "",
  requestStatus:{
    label:'PENDING',
    value :'PENDING'
  } ,
  isShowMarkSpam: false ,
  requestStartDate: null,
  requestEndDate: null,
  actionStartDate: null,
  actionEndDate: null,
  actionBy: "",
  batch: "",
  sortValue: { field: "createdAt", value: "DESC" },
  filterBy: [
    {
      fieldName: "companyName",
      value: [],
    },
    {
      fieldName: "country",
      value: [],
    },
  ],
  dateFilter: {
    start_date: null,
    end_date: null,
  },
};

const registrationRequestsSlice: Slice<RegistrationRequestsSliceStateType> =
  createSlice({
    name: "registrationRequestsSlice",
    initialState,
    reducers: {
      setItems: (state, action: PayloadAction<any[] | []>) => {
        state.items = action.payload;
      },
      setPage: (state, action: PayloadAction<number>) => {
        state.page = action.payload;
        document.getElementById("scroll-top")?.scrollTo(0, 0);
      },
      setRowsPerPage: (state, action: PayloadAction<number>) => {
        state.rowsPerPage = action.payload;
        state.page = 1;
        document.getElementById("scroll-top")?.scrollTo(0, 0);
      },
      setSearchValue: (state, action: PayloadAction<string>) => {
        state.searchValue = action.payload;
        state.page = 1;
      },
      setSortValue: (
        state,
        action: PayloadAction<{ field: string; value: "DESC" | "ASC" }>
      ) => {
        state.sortValue = action.payload;
        state.page = 1;
      },
      setTotalItems: (state, action: PayloadAction<number>) => {
        state.totalItems = action.payload;
      },
      setIsTableLoading: (state, action: PayloadAction<boolean>) => {
        state.isTableLoading = action.payload;
      },
      setFilterBy: (
        state,
        action: PayloadAction<{ fieldName: string; value: string[] }[]>
      ) => {
        state.filterBy = action.payload;
        state.page = 1;
      },
      setDateFilter: (
        state,
        action: PayloadAction<{ start_date: string; end_date: string }>
      ) => {
        state.dateFilter = action.payload;
      },
      setRequestStartDate : (state, action: PayloadAction<any>) => {
        state.requestStartDate = action.payload;
      },
      setRequestEndDate : (state, action: PayloadAction<any>) => {
        state.requestEndDate = action.payload;
      },
      setActionStartDate : (state, action: PayloadAction<any>) => {
        state.actionStartDate = action.payload;
      },
      setActionEndDate : (state, action: PayloadAction<any>) => {
        state.actionEndDate = action.payload;
      },
      setBatch : (state, action: PayloadAction<any>) => {
        state.batch = action.payload;
      },
      setIsShowMarkSpam : (state, action: PayloadAction<any>) => {
        state.isShowMarkSpam = action.payload;
      },
      setRequestStatus : (state, action: PayloadAction<boolean>) => {
        state.requestStatus = action.payload;
      },
      setActionBy : (state, action: PayloadAction<any>) => {
        state.actionBy = action.payload;
      },
    },
  });

export const {
  setItems,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setSortValue,
  setTotalItems,
  setIsTableLoading,
  setDateFilter,
  setFilterBy,
  setActionBy ,
  setActionEndDate ,
  setActionStartDate ,
  setRequestStartDate ,
  setRequestEndDate ,
  setBatch ,
  setIsShowMarkSpam ,
  setRequestStatus
} = registrationRequestsSlice.actions;
export default registrationRequestsSlice.reducer;
